// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_53-6";
export var headerCell = "_53-2";
export var loadingStateContent = "_53-8";
export var rowWrapper = "_53-4";
export var stickyAggregationCell = "_53-b";
export var stickyAggregationRow = "_53-7";
export var stickyColumnCell = "_53-a";
export var stickyColumnHeaderCell = "_53-9";
export var table = "_53-1";
export var virtualRowWrapper = "_53-5";
export var virtualTableContainer = "_53-0";
export var white = "_53-3";